var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297 297",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M181.115,236.463h-22.731V125.768h87.963c5.458,0,9.884-4.425,9.884-9.883V66.961c0-5.458-4.426-9.884-9.884-9.884H50.653 c-5.458,0-9.884,4.426-9.884,9.884v48.924c0,5.458,4.426,9.883,9.884,9.883h87.963v110.695h-22.731 c-5.459,0-9.884,4.426-9.884,9.884c0,5.458,4.425,9.884,9.884,9.884h65.23c5.458,0,9.884-4.426,9.884-9.884 C190.999,240.889,186.573,236.463,181.115,236.463z M60.536,76.845h175.928v29.156H60.536V76.845z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,246.347c0,5.458,4.426,9.884,9.884,9.884s9.883-4.426,9.883-9.884v-55.348h61.772v55.348 c0,5.458,4.426,9.884,9.884,9.884c5.458,0,9.883-4.426,9.883-9.884V148.5c0-5.458-4.425-9.884-9.883-9.884H19.767V50.653 c0-5.458-4.425-9.884-9.883-9.884S0,45.195,0,50.653V246.347z M19.767,158.384h61.772v12.849H19.767V158.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.693,246.347c0,5.458,4.426,9.884,9.884,9.884c5.458,0,9.884-4.426,9.884-9.884v-55.348h61.772v55.348 c0,5.458,4.425,9.884,9.883,9.884c5.458,0,9.884-4.426,9.884-9.884V50.653c0-5.458-4.426-9.884-9.884-9.884 c-5.458,0-9.883,4.426-9.883,9.884v87.963h-71.656c-5.458,0-9.884,4.426-9.884,9.884V246.347z M215.461,171.232v-12.849h61.772 v12.849H215.461z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.8b207a658c6a9bd42398564721af008a.svg";
export { ForwardRef as ReactComponent };